import { alpha, Box, useTheme } from '@mui/material'
import { Dispatch, SetStateAction, useState } from 'react'
import { IFilter } from 'src/components/filter/types/filter.types'

export interface IProps {
  countInfo: number | undefined | void
  filterName: string
  defaultValue: string[]
  setFilter: Dispatch<SetStateAction<IFilter>>
}

export const ConsumerScansInfoWithFilter = ({
  countInfo,
  setFilter,
  filterName,
  defaultValue,
}: IProps) => {
  const theme = useTheme()
  const [active, setActive] = useState(false)

  const handleFilter = () => {
    if (active) {
      setActive(false)
      setFilter((prevFilter) => ({ ...prevFilter, [filterName]: defaultValue }))
    } else {
      setActive(true)
      setFilter((prevFilter) => ({ ...prevFilter, [filterName]: ['unknown'] }))
    }
  }

  if (!countInfo) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: '5px',
        fontSize: '14px',
        p: '2px 16px',
      }}
    >
      <Box
        sx={{
          cursor: 'pointer',
          color: active ? theme.palette.custom.warning : alpha(theme.palette.custom.warning, 0.7),
          borderBottom: `1px solid ${theme.palette.custom.white}`,
          transition: 'color 0.3s ease-in-out, border-color 0.3s ease-in-out',
          '&:hover': {
            color: theme.palette.custom.warning,
            borderBottom: `1px solid ${theme.palette.custom.warning}`,
          },
        }}
        onClick={handleFilter}
      >
        {`${countInfo} potential fake ones`}
      </Box>
    </Box>
  )
}
